import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');
import Vue from 'vue'
export default {
  name: 'quiz-instruction',
  components: {},
  props: [],
  data() {
    return {
      quizType: '',
      quizTitle: ''
    }
  },
  computed: {

  },
  mounted() {
    this.quizType = atob(localStorage.getItem('quiz'));
    if (this.quizType == 'space-exploration') {
      this.quizTitle = 'space Science'
    } else if (this.quizType == 'machine-learning') {
      this.quizTitle = 'Machine Learning';
    } else if (this.quizType == 'finance') {
      this.quizTitle = 'Finance';
    } else if (this.quizType == 'computational-science') {
      this.quizTitle = 'Computational Sciences';
    } else if (this.quizType == 'computer-science') {
      this.quizTitle = 'computer science';
    }
  },
  updated() {
    this.quizType = atob(localStorage.getItem('quiz'));
    if (this.quizType == 'space-exploration') {
      this.quizTitle = 'space Science'
    } else if (this.quizType == 'machine-learning') {
      this.quizTitle = 'Machine Learning';
    } else if (this.quizType == 'finance') {
      this.quizTitle = 'Finance';
    } else if (this.quizType == 'computational-science') {
      this.quizTitle = 'Computational Sciences';
    } else if (this.quizType == 'computer-science') {
      this.quizTitle = 'computer science';
    }
  },
  methods: {
    startQuiz() {
      if (this.quizType == 'space-exploration') {
        this.QuizGameSHow();
      } else if (this.quizType == 'machine-learning') {
        this.QuizGameSHowMachineL();
      } else if (this.quizType == 'finance') {
        this.QuizGameSHowFinance();
      } else if (this.quizType == 'computational-science') {
        this.QuizGameSHowComputationalS();
      } else if (this.quizType == 'computer-science') {
        this.QuizGameSHowCs();
      }
    },
    QuizGameSHow() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameSpace', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizGameSHowCs() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameCS', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizGameSHowFinance() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameFinance', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizGameSHowMachineL() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameMachineLearning', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizGameSHowComputationalS() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      bus.$emit('showQuizGameComputationalS', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    showCategory() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
      }, 500);
      setTimeout(() => {
        bus.$emit('hideQuizCategory', true);
      }, 500);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 600);
    },
    QuizGamePopupClose() {
      $('.quizzort_main_wrp').removeClass('popup_active')
      setTimeout(() => {
        bus.$emit('showQuizInstruction', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
    },
  },

}